var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.296 6.254L1.316 5.554L2.59 3.86L0.56 3.23L0.924 2.068L2.94 2.754L2.898 0.64H4.116L4.088 2.754L6.104 2.068L6.468 3.23L4.452 3.86L5.726 5.554L4.732 6.254L3.514 4.546L2.296 6.254Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequired);
export default __webpack_public_path__ + "static/media/required.e87650d03ca3a5e461a3ff462a0aa213.svg";
export { ForwardRef as ReactComponent };